import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ExpandableContent from 'Component/ExpandableContent';
import ShowMore from 'Component/ShowMore';
import ProductCard from 'Component/ProductCard';

import './ProductCare.style';

export default class ProductCare extends PureComponent {
    state = {};

    static propTypes = {
        areDetailsLoaded: PropTypes.bool.isRequired
    };

    render() {
        const { relatedProducts, areDetailsLoaded } = this.props;

        return (
            <ShowMore mix={ { block: 'ProductCare' } }>
                <div block="ProductSection" elem="Heading">
                    <h3 block="ProductSection" elem="HeadingTitle">{ __('Total care') }</h3>
                    <p>{ __('For optimal results, choose a skincare ritual using the complementary products from this range.') }</p>
                </div>
                <div block="ProductSection" elem="Content">
                    { Object.keys(relatedProducts).map((item, index) => (
                        <ExpandableContent
                          heading={ item }
                          key={ index }
                          isContentExpanded={ index === 0 }
                          mix={ {
                              block: 'ProductCare'
                          } }
                        >
                            <ul block="ProductLinks" elem="List">
                                { relatedProducts[item].map(product => (
                                    <ProductCard
                                      product={ product }
                                      key={ product.id }
                                    />
                                )) }
                            </ul>
                        </ExpandableContent>
                    )) }
                </div>
            </ShowMore>
        );
    }
}
